import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { LOAN_UPDATE_LENDING_PRODUCT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class UpdateLoanLendingProduct extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = [];

  url = LOAN_UPDATE_LENDING_PRODUCT_URL;

  constructor(applicationId, lendingProductId, payLoad) {
    super();
    this.body = payLoad;
    const paramList = [applicationId, lendingProductId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
